var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',_vm._b({attrs:{"type":"hidden","id":_vm.identifier,"name":_vm.name},domProps:{"value":_vm.fieldValue},on:{"input":function($event){return _vm.updateValue($event.target.value)}}},'input',_vm.attributes,false))
}
var staticRenderFns = []

export { render, staticRenderFns }